module.exports = __webpack_public_path__ + "static/media/brjostvodvar_small.8708f0a7.png";